import React from 'react';
import { Facebook, Instagram, ExternalLink } from 'lucide-react';
export function SocialFeed() {
  return <section className="w-full py-16 px-4 bg-white/50" data-id="element-252">
      <div className="max-w-6xl mx-auto flex flex-col items-center" data-id="element-253">
        <h2 className="text-2xl md:text-3xl font-serif text-[#1A1A1A] mb-2" data-id="element-254">
          Följ oss
        </h2>
        <p className="text-[#1A1A1A]/50 text-sm mb-12 text-center max-w-md" data-id="element-255">
          Håll dig uppdaterad med våra senaste bakverk och nyheter. Våra flöden
          uppdateras automatiskt med nytt innehåll.
        </p>

        <div className="w-full flex flex-col lg:flex-row gap-8 items-start justify-center" data-id="element-256">
          {/* Facebook Feed */}
          <div className="flex flex-col items-center w-full lg:w-auto lg:flex-1 max-w-[520px]" data-id="element-257">
            <div className="flex items-center gap-2 mb-4" data-id="element-258">
              <Facebook className="h-5 w-5 text-[#C5A55A]" data-id="element-259" />
              <h3 className="text-lg font-serif text-[#1A1A1A]" data-id="element-260">Facebook</h3>
            </div>

            <div className="bg-white p-3 rounded-xl shadow-sm border border-[#C5A55A]/15 w-full max-w-[520px]" data-id="element-261">
              <div className="w-full overflow-hidden flex justify-center bg-gray-50 rounded-lg" data-id="element-262">
                <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fp%2FTop-Notch-Bakery-100063945724298%2F&tabs=timeline&width=500&height=600&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="500" height="600" style={{
                border: 'none',
                overflow: 'hidden'
              }} scrolling="no" frameBorder="0" allowFullScreen={true} allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" title="Top Notch Bakery Facebook" className="max-w-full" data-id="element-263" />
              </div>
            </div>

            <a href="https://www.facebook.com/p/Top-Notch-Bakery-100063945724298/" target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#C5A55A] transition-colors" data-id="element-264">
              <span data-id="element-265">Besök Facebook-sida</span>
              <ExternalLink className="h-3.5 w-3.5" data-id="element-266" />
            </a>
          </div>

          {/* Instagram Feed */}
          <div className="flex flex-col items-center w-full lg:w-auto lg:flex-1 max-w-[520px]" data-id="element-267">
            <div className="flex items-center gap-2 mb-4" data-id="element-268">
              <Instagram className="h-5 w-5 text-[#C5A55A]" data-id="element-269" />
              <h3 className="text-lg font-serif text-[#1A1A1A]" data-id="element-270">Instagram</h3>
            </div>

            <div className="bg-white p-3 rounded-xl shadow-sm border border-[#C5A55A]/15 w-full max-w-[520px]" data-id="element-271">
              <div className="w-full overflow-hidden flex justify-center bg-gray-50 rounded-lg" data-id="element-272">
                <iframe src="https://www.instagram.com/top.notch.bakery/embed/" width="500" height="600" style={{
                border: 'none',
                overflow: 'hidden'
              }} scrolling="yes" frameBorder="0" allowFullScreen={true} title="Top Notch Bakery Instagram" className="max-w-full" data-id="element-273" />
              </div>
            </div>

            <a href="https://www.instagram.com/top.notch.bakery" target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#C5A55A] transition-colors" data-id="element-274">
              <span data-id="element-275">Besök Instagram-profil</span>
              <ExternalLink className="h-3.5 w-3.5" data-id="element-276" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}